export function logoutUser(navigate?: (path: string) => void) {
    localStorage.removeItem("token");
    sessionStorage.clear(); // optional
    if (navigate) {
        navigate("/");
    } else {
        window.location.href = "/";
    }
}